<template>
  <div class="identificationBox">
    <div class="content">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <!-- 风险点辨识的清单 -->
        <el-tab-pane label="安全风险分级辨识清单" name="first">
          <Input v-model="searchContentBS" search enter-button placeholder="请输入风险点名称" @on-search="searchBS" style="width: 250px; float: right" />
          <el-table :data="tableDataBS" style="width: 100%;">
            <el-table-column type="expand">
              <template slot-scope="props">
                <el-table :data="props.row.measure" border style="width: 100%"
                  :header-cell-style="{ background: 'white', fontWeight: 400, textAlign: 'center', padding: '8px 0' }"
                  :cell-style="{ textAlign: 'center' }"
                >
                  <el-table-column label="辨识内容">
                    <el-table-column prop="project" label="检查项目/作业步骤" width="180"></el-table-column>
                    <el-table-column prop="name" label="检查标准/风险源或潜在事件" width="200"></el-table-column>
                    <el-table-column prop="riskFactor" label="风险要素"></el-table-column>
                    <el-table-column prop="riskDescription" label="不符合标准状况/可能发生事故描述" width="250"></el-table-column>
                    <el-table-column prop="type" label="易发事故类型"></el-table-column>
                    <el-table-column prop="consequence" label="危害/后果"></el-table-column>
                    <el-table-column prop="riskControlId" label="管控状态">
                      <template slot-scope="{ row }">
                        <span v-if="row.riskControlId === 0" style="color: red">未管控</span>
                        <span v-else style="color: #67C23A">已管控</span>
                      </template>
                    </el-table-column>
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column type="index" :index="addIndex" label="序号" width="50" />
            <el-table-column label="辨识名称" prop="name"></el-table-column>
            <el-table-column label="风险点" prop="riskName"></el-table-column>
            <el-table-column label="所属部门" prop="depName"></el-table-column>
            <el-table-column label="责任人" prop="responsibleEmpName"></el-table-column>
            <el-table-column label="辨识人" prop="identifyUserName"></el-table-column>
            <el-table-column label="辨识日期" prop="gmtCreate" />
            <el-table-column label="操作">
              <template slot-scope="{ row }">
                <span v-if="row.identifyUserId === userId && row.status === 0" class="wordBtn" style="color: #f56c6c" @click="editBS(row)">编辑</span>
                <span v-if="row.auditUserId === userId && row.status === 0" class="wordBtn" style="color: #e6a23c" @click="examineBS(row)">
                  审核
                </span>
                <span class="wordBtn" @click="detailBS(row)">详情</span>
                <span class="wordBtn" @click="deleteBS(row)" style="color: red">删除</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="pageBox">
            <Page
              :total="total1"
              :page-size="limit1"
              @on-change="handleChange1"
              :current="curPage1"
            />
          </div>
        </el-tab-pane>
        <!-- 辨识,管控,审核弹窗 -->
        <el-dialog
          :title="activeName === 'first' ? '辨识审核' : '管控审核'"
          :visible.sync="dialogVisibleBS"
          width="30%"
          :before-close="handleCloseBS">
          <el-form :model="bsForm" ref="bsForm" :rules="rulesBS" label-width="80">
            <el-form-item label="审核意见" prop="auditOpinion">
              <el-input v-model="bsForm.auditOpinion" type="textarea" :rows="3" />
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="handleCloseBS" size="small">取 消</el-button>
            <el-button type="primary" @click="sureBS" size="small">确 定</el-button>
          </span>
        </el-dialog>
        <!-- 风险管控的清单 -->
        <el-tab-pane label="安全风险分级管控清单" name="second">
          <Input v-model="searchContentGK" search enter-button placeholder="请输入风险点名称" @on-search="searchGK" style="width: 250px; float: right;margin-bottom: 15px" />
          <el-table
            :data="tableDataGK"
            :header-cell-style="{ fontWeight: 500, color: 'rgb(0,0,0)', background: '#fafafa', textAlign: 'center', padding: '8px 0' }"
            :cell-style="{ textAlign: 'center' }"
            style="width: 100%"
          >
            <el-table-column type="index" :index="addIndex2" label="序号" width="50"></el-table-column>
            <el-table-column prop="name" label="风险管控名"></el-table-column>
            <el-table-column prop="riskName" label="风险点"></el-table-column>
            <el-table-column prop="depName" label="所属部门"></el-table-column>
            <el-table-column label="管控措施" show-overflow-tooltip>
              <el-table-column label="工程技术措施">
                <template slot-scope="{ row }"><span v-if="row.measure">{{ row.measure.technicalMeasure }}</span></template>
              </el-table-column>
              <el-table-column label="管理措施" show-overflow-tooltip>
                <template slot-scope="{ row }"><span v-if="row.measure">{{ row.measure.managementMeasure }}</span></template>
              </el-table-column>
              <el-table-column label="培训教育措施" show-overflow-tooltip>
                <template slot-scope="{ row }"><span v-if="row.measure">{{ row.measure.trainingMeasure }}</span></template>
              </el-table-column>
              <el-table-column label="个体防护措施" show-overflow-tooltip>
                <template slot-scope="{ row }"><span v-if="row.measure">{{ row.measure.personalFenceMeasure }}</span></template>
              </el-table-column>
              <el-table-column label="应急处置措施" show-overflow-tooltip>
                <template slot-scope="{ row }"><span v-if="row.measure">{{ row.measure.emergencyMeasure }}</span></template>
              </el-table-column>
            </el-table-column>
            <el-table-column prop="responsibleEmpName" label="责任人" />
            <el-table-column prop="controlEmpName" label="管控人" />
            <el-table-column label="风险等级">
              <template slot-scope="{ row }">
                <el-tag v-if="row.controlLevel === 0" effect="dark" type="danger" size="small">重大风险</el-tag>
                <el-tag v-if="row.controlLevel === 1" effect="dark" type="warning" size="small">较大风险</el-tag>
                <el-tag v-if="row.controlLevel === 2" effect="dark" style="color: #666666;background: yellow;borderColor: yellow" size="small">一般风险</el-tag>
                <el-tag v-if="row.controlLevel === 3" effect="dark" size="small">低风险</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="controlHierarchy" label="管控层级">
              <template slot-scope="{ row }">
                {{ controlHierarchyList[row.controlHierarchy] }}
              </template>
            </el-table-column>
            <el-table-column prop="nextEvaluateTime" label="管控日期">
              <template slot-scope="{ row }"><span v-if="row.nextEvaluateTime">{{ row.nextEvaluateTime | filter1 }}</span></template>
            </el-table-column>
            <el-table-column label="操作" width="130">
              <template slot-scope="{ row }">
                <span v-if="row.controlUserId === userId && row.status === 0" class="wordBtn" style="color: #f56c6c" @click="editGK(row)">编辑</span>
                <span v-if="row.auditUserId === userId && row.status === 0" class="wordBtn" style="color: #e6a23c" @click="examineBS(row)">
                  审核
                </span>
                <span v-if="row.status === 1 && row.auditUserId === userId" class="wordBtn" style="color: #e6a23c;width: 70px" @click="review(row.id)">管控跟踪</span>
                <span class="wordBtn" @click="detailGK(row)">详情</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="pageBox">
            <Page
              :total="total2"
              :page-size="limit2"
              @on-change="handleChange2"
              :current="curPage2"
            />
          </div>
          <!-- 风险管控-复评的弹窗 -->
          <el-dialog
            title="管控跟踪"
            :visible.sync="dialogVisibleReview"
            width="30%"
            :before-close="handleCloseReview">
            <el-form :model="reviewForm" size="small" :rules="reviewRules" ref="reviewForm" label-width="110px">
              <el-form-item label="落实状况" prop="implementation">
                <el-input type="textarea" :rows="3" v-model="reviewForm.implementation" />
              </el-form-item>
              <el-form-item label="补充管控措施" prop="managementMeasure">
                <el-input type="textarea" :rows="3" v-model="reviewForm.managementMeasure" />
              </el-form-item>
              <el-form-item label="复评时间" prop="nextEvaluateTime">
                <el-date-picker
                  v-model="reviewForm.nextEvaluateTime"
                  type="date"
                  style="width: 100%"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间"
                />
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button size="small" @click="handleCloseReview">取 消</el-button>
              <el-button size="small" type="primary" @click="reviewSure">确 定</el-button>
            </span>
          </el-dialog>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { riskIdentifyList, riskControlList, riskIdentifyExaminee, riskControlExaminee,
  riskControlReview, riskIdentifyDelete } from "@/api/processManager";
export default {
  data() {
    return {
      userId: '',
      activeName: "first",
      // 风险点辨识的表格数据
      searchContentBS: '',
      tableDataBS: [],
      total1: 0,
      curPage1: 1,
      limit1: 10,
      bsForm: {
        auditOpinion: '',
        id: ''
      },
      rulesBS: {
        auditOpinion: [{ required: true, message: '请输入审核意见' }]
      },
      // 辨识弹窗
      dialogVisibleBS: false,
      // 风险点管控的列表数据
      searchContentGK: '',
      tableDataGK: [],
      total2: 0,
      curPage2: 1,
      limit2: 10,
      // 管控审核弹窗
      dialogVisibleGK: false,
      // 管控复评的东西
      dialogVisibleReview: false,
      reviewForm: {
        riskControlId: '',
        implementation: '',
        managementMeasure: '',
        nextEvaluateTime: ''
      },
      reviewRules: {
        implementation: [{ required: true, message: '请输入落实情况' }],
        managementMeasure: [{ required: true, message: '请输入补充管控措施' }],
        nextEvaluateTime: [{ required: true, message: '请选择复评时间' }]
      },
      // 管控层级的数组
      controlHierarchyList: ['公司级', '车间级', '班组级', '岗位级']
    };
  },
  filters: {
    filter1(time) {
      return time.split(' ')[0]
    }
  },
  created() {
    this.userId = Number(localStorage.getItem('userId'));
    // console.log(this.userId)
    if(this.$route.query.status === 'second') {
      if(this.$route.query.searchContent) {
        this.searchContentGK = this.$route.query.searchContent
      }
      this.activeName = 'second';
      if(this.$route.query.id) {
        riskControlList({ limit: this.limit2, curPage: this.curPage2, search: this.searchContentGK, dangerInfoId: this.$route.query.id }).then(
          res => {
            this.tableDataGK = res.body.data;
            this.total2 = res.body.cum;
          }
        );
      } else {
        this.getTableGK();
      }
    } else {
      if(this.$route.query.searchContent) {
        this.searchContentBS = this.$route.query.searchContent
      }
      this.getTableBS();
    }
  },
  methods: {
    // 序号递增
    addIndex(index) {
      return (this.curPage1 - 1) * this.limit1 + index + 1;
    },
    addIndex2(index) {
      return (this.curPage2 - 1) * this.limit2 + index + 1;
    },
    handleClick(row) {
      if (row.name === 'first') {
        this.getTableBS();
      } else {
        this.getTableGK();
      }
    },
    // 获取辨识列表
    getTableBS() {
      riskIdentifyList({ limit: this.limit1, curPage: this.curPage1, search: this.searchContentBS }).then(
        res => {
          this.tableDataBS = res.body.data;
          this.total1 = res.body.cum;
        }
      );
    },
    searchBS() {
      this.getTableBS();
    },
    // 风险点辨识的表格事件
    handleChange1(val) {
      this.curPage1 = val;
      this.getTableBS();
    },
    // 表格的类(样式)
    cellClassName({ row, column, rowIndex, columnIndex }) {
      if (columnIndex >= 4 && columnIndex <= 9) {
        return "cellClass22";
      }
    },
    // 辨识编辑
    editBS(row) {
      let obj = { ...row };
      for(let i in obj) {
        if(obj[i] === null) {
          delete obj[i]
        }
      }
      this.$router.push({
        name: 'AddriskPointIdentification',
        params: { data: obj }
      })
    },
    // 辨识详情
    detailBS(row) {
      this.$router.push({
        name: "riskIdentificationDetail",
        params: { data: row }
      });
    },
    // 辨识删除
    deleteBS(row) {
      this.$confirm(`删除风险点 '${row.riskName}' 的该条辨识, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        riskIdentifyDelete(row.id).then(res => {
          this.$message.success('删除成功')
          this.getTableBS()
        })
      }).catch(() => {
        return
      });
    },
    // 打开辨识(管控)审核弹窗
    examineBS(row) {
      this.bsForm.id = row.id;
      this.dialogVisibleBS = true;
    },
    // 辨识
    sureBS() {
      this.$refs['bsForm'].validate((valid) => {
        if (valid) {
          // 辨识
          if(this.activeName === 'first') {
            riskIdentifyExaminee({ ...this.bsForm }).then(res => {
              this.$message.success('审核成功')
              this.getTableBS();
              this.handleCloseBS();
            })
          // 管控
          } else if(this.activeName === 'second') {
            riskControlExaminee({ ...this.bsForm }).then(res => {
              this.$message.success('审核成功')
              this.getTableGK();
              this.handleCloseBS();
            })
          }
        } else {
          return false;
        }
      });
    },
    // 关闭辨识审核弹窗
    handleCloseBS() {
      this.$refs['bsForm'].resetFields();
      this.dialogVisibleBS = false;
    },
    // 获取管控列表
    getTableGK() {
      riskControlList({ limit: this.limit2, curPage: this.curPage2, search: this.searchContentGK }).then(
        res => {
          this.tableDataGK = res.body.data;
          this.total2 = res.body.cum;
        }
      );
    },
    searchGK() {
      this.getTableGK();
    },
    // 管控页码改变
    handleChange2(val) {
      this.curPage2 = val;
      this.getTableGK();
    },
    // 管控编辑
    editGK(row) {
      let obj = { ...row };
      for(let i in obj) {
        if(obj[i] === null) {
          delete obj[i]
        }
      };
      this.$router.push({
        name: 'AddRiskPointControl',
        params: { data: obj }
      })
    },
    // 管控详情
    detailGK(row) {
      // console.log(row);
      this.$router.push({
        name: "riskControlDetail",
        params: { data: row }
      });
    },
    // 打开复评弹窗
    review(id) {
      this.reviewForm.riskControlId = id
      this.dialogVisibleReview = true
    },
    // 关闭复评弹窗
    handleCloseReview() {
      this.$refs['reviewForm'].resetFields()
      this.dialogVisibleReview = false
    },
    // 复评
    reviewSure() {
      this.$refs['reviewForm'].validate((valid) => {
        if (valid) {
          riskControlReview({ ...this.reviewForm }).then(res => {
            this.getTableGK()
            this.$message.success('复评成功')
            this.handleCloseReview()
          })
        }
        else {
          return false;
        }
      })
    },
  },
};
</script>

<style scoped>
.head1 {
  position: absolute;
  top: 0px;
  left: 250px;
  width: 80%;
  height: 60px;
}
.pageBox {
  text-align: right;
  margin-top: 10px;
}
.wordBtn {
  cursor: pointer;
  margin-right: 3px;
  display: inline-block;
  width: 32px
}
.identificationBox /deep/ .cellClass22 {
  padding: 0px;
  border-bottom: none;
}
.identificationBox /deep/ .cellClass22 .cell {
  padding: 0px;
  line-height: 30px;
  text-align: center;
}
.identificationBox /deep/ .aaa {
  display: flex;
  flex-direction: column;
}
td {
  word-break: break-all;
}
.aaa {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
</style>
